import { ClienteMicroseg } from '../../model/cliente-microseg/cliente-microseg';

/**
 * Puerto Abstracto: ClienteMicrosegRepository
 * 
 * Define el contrato para gestión de microsegmentaciones de cliente.
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpClienteMicrosegRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class ClienteMicrosegRepository {

  /**
   * Obtiene las microsegmentaciones activas filtradas por cliente.
   *
   * @param nmconsecutivoCliente Código del cliente (aseguradora)
   * @returns Lista de microsegmentaciones activas
   */
  abstract obtenerMicrosegmentaciones(nmconsecutivoCliente: number): Promise<ClienteMicroseg[]>;
}
